import React, { Component } from 'react';
import { connect } from 'react-redux';
import { rsvpUser, addUserToRollCall } from '../actions';
//TODO, this component mixes RSVP and Roll Call. In the future, it should be 2 separate components.
class RSVPButton extends Component {

	constructor( props ) {
		super( props );
		let RSVPStatus = 'Not Confirmed';
		this.state = {
			show: [], rsvp: [], rsvpStatus: RSVPStatus, roll_call: []
		};
	}

	getRSVPStatus() {
		if ( typeof this.props.meeting.RSVP.rsvp_type !== 'undefined' ) {
			switch ( this.props.meeting.RSVP.rsvp_type ) {
				case 'dial_in':
				case 'dialin':
					return 'Dial-In';
					break;
				case 'in_person':
					return 'In Person';
					break;
				case 'no_show':
				case 'noshow':
					return 'Not Attending';
					break;
				default:
					return this.props.meeting.RSVP.rsvp_type;
					break;
			}
		} else {
			return 'Not Confirmed';
		}

	}

	getRSVPOptionsBasedOnMeeting(rsvp_details){
		let dialIn = '';
		let inPerson = '';
		const dial_in_on = (typeof rsvp_details.RSVP_dial_in !== 'undefined') ? (rsvp_details.RSVP_dial_in === 'on') : false;
		const in_person_on = (typeof rsvp_details.RSVP_in_person !== 'undefined') ? (rsvp_details.RSVP_in_person === 'on') : false;
		if ( dial_in_on ) {
			dialIn = (
				<button onClick={ this.userRSVP.bind( this, 'Dial-In' ) } data-ccode={ this.props.ccode } data-meeting-id={ this.props.meet_id } className="meeting-btn rsvp-action rsvp-roll-call-button" type="button">Dial-In</button>
			);
		}
		if ( in_person_on ) {
			inPerson = (
				<button onClick={ this.userRSVP.bind( this, 'In Person' ) } data-ccode={ this.props.ccode } data-meeting-id={ this.props.meet_id } className="meeting-btn rsvp-action rsvp-roll-call-button" type="button">In Person</button>
			);
		}
		return (<div className='rsvp-container'>
				{ dialIn }
				<button onClick={ this.userRSVP.bind( this, 'Not Attending' ) } data-ccode={ this.props.ccode } data-meeting-id={ this.props.meet_id } className="meeting-btn rsvp-action rsvp-roll-call-button" type="button">Not Attending</button>
				{ inPerson }
			</div>
		);
	}

	getRSVPState() {

		const rsvp_details = this.props.meeting.RSVP_details;
		//If custom rsvp options are available, use that. If not, use meeting based options.
		if ( typeof rsvp_details.rsvp_options !== 'undefined' && rsvp_details.rsvp_options.length > 0 ) {
			var rsvpButtons = rsvp_details.rsvp_options.map( option => (
				<button onClick={ this.userRSVP.bind( this, option, option ) } data-ccode={ this.props.ccode } data-meeting-id={ this.props.meet_id } className="btn btn-primary committee-rsvp-option-button rsvp-roll-call-button rsvp-action">{ option }</button>
			) );
			return (<div className='rsvp-options-container'>
					{ rsvpButtons }
				</div>
			);
		} else {
			return this.getRSVPOptionsBasedOnMeeting(rsvp_details);
		}
	}

	userRSVP( rsvpStatus ) {
		let newState = this.state;
		newState.rsvp[ this.props.meet_id ] = rsvpStatus;
		newState.show = this.toggleShowState( false );
		this.props.rsvpUser( this.props.ccode, this.props.meet_id, rsvpStatus );
		this.setState( newState );
	}

	toggleShowState( set_state = true ) {
		let newState = this.state;
		let meet_id = this.props.meet_id;
		let show_arr = this.state.show;
		show_arr = addOrRemoveFromArray(show_arr,meet_id);
		if ( set_state ) {
			newState.show = show_arr;
			this.setState( newState );
		} else {
			return show_arr;
		}
	}

	setMeetingRSVPState() {
		let newState = this.state;
		let meeting_id = this.props.meet_id;
		newState.rsvp[ meeting_id ] = this.getRSVPStatus();
		this.setState( newState );
	}

	getRSVPLabel() {
		let status = 'Not Confirmed';
		if ( typeof this.state.rsvp[ this.props.meet_id ] !== 'undefined' ) {
			status = this.state.rsvp[ this.props.meet_id ];
		}
		return (
			<span><strong>RSVP Status</strong>: { status } </span>
		);
	}

	changeRollCallState() {
		let admissionData = {
			ID                   : getImisInfo().ContactMaster,
			name                 : getImisInfo().name,
			email                : getImisInfo().UserName.toLowerCase(),
			company_name         : getImisInfo().company_name,
			company_id           : getImisInfo().company_id,
			logged_in            : true,
			committee_participant: true,
			parent_company_name  : getImisInfo().parent_company_name,
			parent_company_id    : getImisInfo().parent_company_id,
			is_from_dashboard    : true
		};
		this.props.addUserToRollCall( admissionData, this.props.meet_id );
	}

	render() {
		let meeting = this.props.meeting;
		let has_rsvp_details = (typeof this.props.meeting.RSVP_details !== 'undefined'
		                       )
			? this.props.meeting.RSVP_details.RSVP_link_status === 'on'
			: false;
		if ( meeting.RSVP !== false && typeof this.state.rsvp[ meeting.ID ] === 'undefined' ) {
			this.setMeetingRSVPState();
		}

		if ( !has_rsvp_details ) {
			return (<div></div>
			);
		}

		let RSVPText = 'RSVP';
		let hide_rsvp = '';
		if ( typeof this.props.meeting.RSVP.rsvp_type !== 'undefined' || typeof this.state.rsvp[ this.props.meet_id ] !== 'undefined' ) {
			RSVPText = 'RSVP Confirmed';
		}
		let rsvpState = '';
		if ( this.state.show.includes( this.props.meet_id ) ) {
			hide_rsvp = 'hide';
			rsvpState = this.getRSVPState();
		}
		let buttonAction = (this.props.button_type === 'rsvp'
		                   ) ? (
			                   <button onClick={ this.toggleShowState.bind( this ) } className={ 'meeting-btn ' + hide_rsvp } type="button">{ RSVPText }</button>
		                   ) : (
			                   <button className={ 'meeting-btn roll-call-action rsvp-roll-call-button' } onClick={ this.changeRollCallState.bind( this ) } type="button" data-ccode={ this.props.ccode } data-meeting-id={ this.props.meet_id }>Roll Call</button>
		                   );
		if ( this.props.rollCallState.includes( this.props.meet_id ) ) {
			return (
				<div className="meeting-attendance-container">
					<div className="roll-call-submitted">
						<span className="glyphicon glyphicon-ok" />
						<p>Participating in Roll Call.</p></div>
				</div>
			);
		} else {
			return (
				<div className="meeting-attendance-container">
					{ this.getRSVPLabel() }
					<div className={ 'committee-rsvp-link rsvp-container ' } data-ccode={ this.props.ccode } data-meet-id={ this.props.meet_id }> { buttonAction }
						{ rsvpState }
					</div>
				</div>
			);
		}

	}

}

function mapStateToProps( { rollCallState } ) {
	return {
		rollCallState
	};
}

export default connect( mapStateToProps, {
	rsvpUser,
	addUserToRollCall
} )( RSVPButton );